import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/blog-post/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));
const ThankYouContactPage = lazy(() => import('../pages/thank-you-contact/page'));
const ThankYouDownloadPage = lazy(() => import('../pages/thank-you-download/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '/thank-you-contact',
    element: <ThankYouContactPage />,
  },
  {
    path: '/thank-you-download',
    element: <ThankYouDownloadPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
